module.exports = __webpack_public_path__ + "static/media/30_plantilla_rec_combo_simple_cp_gaseosas_pet_237_sp.e1839d59.png";